(function (app, ng) {
    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state("Home.ConfigureSystem", {
            url: "/ConfigureSystem",
            component: "configureSystem",
            resolve: {}
        });
    }]);

    app.component("configureSystem",
    {
        templateUrl: "/App/ConfigureSystem/template.html",
        controller: configureSystemController,
        bindings: {}
    });

    configureSystemController.$inject = ["$mdDialog"];

    function configureSystemController($mdDialog) {
        var $ctrl = this;

        ng.extend($ctrl,
        {
            goToManageProducts: goToManageProducts,
            goToManageTransactionGroups: goToManageTransactionGroups
        });

        function goToManageProducts() {
            var alert = $mdDialog.alert({
                templateUrl: "/App/ConfigureSystem/ManageProducts/template.html",
                controller: "manageProductsController",
                controllerAs: "$ctrl",
                resolve: {
                    products: ["productApi", function(productApi) {
                        return productApi.getProducts();
                    }]
                },
                clickOutsideToClose: false
            });

            $mdDialog.show(alert);
        }
        
        function goToManageTransactionGroups() {
        }
    }
})(window.app, window.angular); // jshint ignore:line